<template>
  <div style="width: 100%">
    <table cellspacing="0" cellpadding="0" border="1" v-if="dataInfo && dataInfo.id">
      <!-- 专项简历 -->
      <tbody>
        <tr style="border-top: 1px solid transparent !important">
          <td width="8%"></td>
          <td width="15%"></td>
          <td width="15%"></td>
          <td width="11%"></td>
          <td width="12%"></td>
          <td width="11%"></td>
          <td width="12%"></td>
          <td width="16%"></td>
        </tr>
        <tr>
          <td class="classA" colspan="2">姓名</td>
          <td class="classB">{{ dataInfo.name }}</td>
          <td class="classA">性别</td>
          <td class="classB">{{ dicOptions.hr_sex.filter((d) => d.dictValue == dataInfo.sex)[0]?.dictLabel }}</td>
          <td class="classA">出生年月</td>
          <td class="classB">
            {{ dataInfo.birthday ? formatDate('YYYY.MM', new Date(dataInfo.birthday)) : '' }}
          </td>
          <td rowspan="5" class="classA" style="background: #fafafa">
            <img v-if="dataInfo.photo" :src="dataInfo.photo" height="175" />
            <img v-else src="../../assets/resumePhoto.png" height="175" />
          </td>
        </tr>
        <tr>
          <td colspan="2" class="classA">民族</td>
          <td class="classB">{{ dicOptions.hr_national.filter((d) => d.dictValue == dataInfo.nation)[0]?.dictLabel }}</td>
          <td class="classA">籍贯</td>
          <td class="classB">{{ findAreaName(dicOptions.areaVos, dataInfo.nativeplace) }}</td>
          <td class="classA" :class="{ tip: dataInfo.nativeLocal === null }">户籍所在地</td>
          <td class="classB">
            {{ findAreaName(dicOptions.areaVos, dataInfo.nativeLocal) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="classA">政治面貌</td>
          <td class="classB">{{ dicOptions.hr_political.filter((d) => d.dictValue == dataInfo.political)[0]?.dictLabel }}</td>
          <td class="classA" :class="{ tip: dataInfo.health === null }">{{ BASIC.health }}</td>
          <td class="classB">
            {{ dicOptions.hr_health.filter((d) => d.dictValue == dataInfo.health)[0]?.dictLabel }}
          </td>
          <td class="classA" :class="{ tip: dataInfo.maritalStatus === null }">{{ BASIC.maritalStatus }}</td>
          <td class="classB">
            {{ dicOptions.hr_marry.filter((d) => d.dictValue == dataInfo.maritalStatus)[0]?.dictLabel }}
          </td>
        </tr>
        <tr>
          <td class="classA" colspan="2" :class="{ tip: isSpecific && dataInfo.currentWork === null }">{{ BASIC.currentWork }}</td>
          <td class="classB" colspan="3">{{ dataInfo.currentWork }}</td>
          <td class="classA">参加工作时间</td>
          <td class="classB">
            {{ dataInfo.workDate ? formatDate('YYYY.MM', new Date(dataInfo.workDate)) : '' }}
          </td>
          <!-- <td class="classA">入党时间</td>
          <td class="classB">
            {{ dataInfo.joinDate ? formatDate('YYYY.MM', new Date(dataInfo.joinDate)) : '' }}
          </td> -->
        </tr>
        <tr>
          <td class="classA" colspan="2">报考岗位名称</td>
          <td class="classB">{{ (job && job.jobName) || '' }}</td>
          <td class="classA" :class="{ tip: isSpecific && dataInfo.profession === null }">{{ BASIC.profession }}</td>
          <td class="classB">{{ dataInfo.profession }}</td>
          <td class="classA">{{ BASIC.professionDate }}</td>
          <td class="classB">
            {{ dataInfo.professionDate ? formatDate('YYYY.MM', new Date(dataInfo.professionDate)) : '' }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="classA">{{ BASIC.address }}</td>
          <td colspan="2" class="classB">
            {{ findAreaName(dicOptions.areaVos, dataInfo.address) + ' ' + (dataInfo.addressDetail || '') }}
          </td>
          <td class="classA">联系电话</td>
          <td class="classB">{{ dataInfo.phoneNumber }}</td>
          <td class="classA">{{ BASIC.idNumber }}</td>
          <td class="classB">{{ dataInfo.idNumber }}</td>
        </tr>

        <tr style="height: 35px" :class="{ tip: dataInfo.cvEducationalList.length == 0 }">
          <td :rowspan="dataInfo.cvEducationalList.length ? dataInfo.cvEducationalList.length + 1 : 2" class="classA">教育经历</td>
          <td class="classA" :class="{ tip: dataInfo.cvEducationalList.some((i) => i.type === null) }">教育类型</td>
          <td class="classA">起止时间</td>
          <td colspan="3" class="classA">毕业院校及专业</td>
          <td colspan="2" class="classA">学历学位</td>
        </tr>
        <tr v-if="dataInfo.cvEducationalList.length == 0">
          <td class="classB"></td>
          <td class="classB"></td>
          <td colspan="3" class="classB"></td>
          <td colspan="3" class="classB"></td>
        </tr>
        <tr v-for="item in dataInfo.cvEducationalList.sort((a, b) => b.education - a.education)" :key="item.id">
          <td class="classB">
            {{ dicOptions.hr_edu_type.filter((d) => d.dictValue == item.type)[0]?.dictLabel }}
          </td>
          <td class="classB">
            {{
              [item.startDate, item.endDate]
                .filter((i) => i)
                .map((i) => formatDate('YYYY.MM', new Date(i)))
                .join('-')
            }}
          </td>
          <td v-if="item.school || item.major" colspan="3" class="classB">{{ item.school }} / {{ item.major }}</td>
          <td v-else colspan="3" class="classB"></td>
          <td colspan="2" class="classB">
            {{ dicOptions.hr_education.filter((d) => d.dictValue == item.education)[0]?.dictLabel }} /
            {{ dicOptions.degree_type.filter((d) => d.dictValue == item.degree)[0]?.dictLabel }}
          </td>
        </tr>

        <tr style="height: 35px" :class="{ tip: isSpecific && dataInfo.cvRecordList.length == 0 }">
          <td :rowspan="dataInfo.cvRecordList.length ? dataInfo.cvRecordList.length + 1 : 2" class="classA">
            {{ isSpecific ? '工作经历' : '工作或实习经历' }}
          </td>
          <td class="classA">起止时间</td>
          <td colspan="3" class="classA">工作单位</td>
          <td colspan="2" class="classA">从事岗位与职务</td>
          <td class="classA">证明人及联系方式</td>
        </tr>
        <tr v-if="dataInfo.cvRecordList.length == 0">
          <td class="classB"></td>
          <td colspan="3" class="classB"></td>
          <td colspan="2" class="classB"></td>
          <td class="classB"></td>
        </tr>
        <tr v-for="item in dataInfo.cvRecordList" :key="item.id">
          <td class="classB">
            {{
              [item.startDate, item.endDate]
                .filter((i) => i)
                .map((i) => formatDate('YYYY.MM', new Date(i)))
                .join('-')
            }}
          </td>
          <td colspan="3" class="classB">
            {{ item.workUnit }}
            <!-- / {{ item.department }} -->
          </td>
          <td colspan="2" class="classB">{{ item.position }}</td>
          <td class="classB">{{ item.witness + (item.witnessNumber ? '/' + item.witnessNumber : '') }}</td>
        </tr>

        <template v-if="isSpecific">
          <tr style="height: 35px" :class="{ tip: dataInfo.cvAwardList.length == 0 }">
            <td :rowspan="dataInfo.cvAwardList.length ? dataInfo.cvAwardList.length + 1 : 2" class="classA">业务获奖<br />情况</td>
            <td class="classA">获奖时间</td>
            <td colspan="3" class="classA">获奖作品名称</td>
            <td colspan="2" class="classA">奖项名称</td>
            <td class="classA">获奖等次及排名</td>
          </tr>
          <tr v-if="dataInfo.cvAwardList.length == 0">
            <td class="classB"></td>
            <td colspan="3" class="classB"></td>
            <td colspan="2" class="classB"></td>
            <td class="classB"></td>
          </tr>
          <tr v-for="item in dataInfo.cvAwardList" :key="item.id">
            <td class="classB">
              {{ item.awardDate ? formatDate('YYYY.MM', new Date(item.awardDate)) : '' }}
            </td>
            <td colspan="3" class="classB">{{ item.title }}</td>
            <td colspan="2" class="classB">{{ item.awardName }}</td>
            <td class="classB">{{ item.level }} | {{ item.rank }}</td>
          </tr>
        </template>

        <!-- <template v-if="isSpecific">
          <tr style="height: 35px" :class="{ tip: dataInfo.cvAchievementList.length == 0 }">
            <td :rowspan="dataInfo.cvAchievementList.length ? dataInfo.cvAchievementList.length + 1 : 2" class="classA">主要业绩<br />成果</td>
            <td class="classA">{{ ACHIEVEMENT.finishTime }}</td>
            <td colspan="3" class="classA">{{ ACHIEVEMENT.project }}</td>
            <td colspan="3" class="classA">{{ ACHIEVEMENT.effect }}</td>
          </tr>
          <tr v-if="dataInfo.cvAchievementList.length == 0">
            <td class="classB"></td>
            <td colspan="3" class="classB"></td>
            <td colspan="3" class="classB"></td>
          </tr>
          <tr v-for="item in dataInfo.cvAchievementList" :key="item.id">
            <td class="classB">
              {{ item.finishTime ? formatDate('YYYY.MM', new Date(item.finishTime)) : '' }}
            </td>
            <td colspan="3" class="classB">{{ item.project }}</td>
            <td colspan="3" class="classB">{{ item.effect }}</td>
          </tr>
        </template> -->

        <template v-if="isSpecific">
          <tr style="height: 35px">
            <td :rowspan="dataInfo.cvPublicationList.length ? dataInfo.cvPublicationList.length + 1 : 2" class="classA">论文论著<br />情况</td>
            <td class="classA">出版时间</td>
            <td colspan="3" class="classA">论文论著名称</td>
            <td colspan="2" class="classA">刊物名/出版社</td>
            <td class="classA">个人排名</td>
          </tr>
          <tr v-if="dataInfo.cvPublicationList.length == 0">
            <td class="classB"></td>
            <td colspan="3" class="classB"></td>
            <td colspan="2" class="classB"></td>
            <td class="classB"></td>
          </tr>
          <tr v-for="item in dataInfo.cvPublicationList" :key="item.id">
            <td class="classB">
              {{ item.pubDate ? formatDate('YYYY.MM', new Date(item.pubDate)) : '' }}
            </td>
            <td colspan="3" class="classB">{{ item.title }}</td>
            <td colspan="2" class="classB">{{ item.institution }}</td>
            <td class="classB">{{ item.rank }}</td>
          </tr>
        </template>

        <template v-if="isSpecific">
          <tr style="height: 35px">
            <td :rowspan="dataInfo.cvHonorList.length ? dataInfo.cvHonorList.length + 1 : 2" class="classA">所获荣誉/<br />表彰奖励</td>
            <td class="classA">获得时间</td>
            <td colspan="3" class="classA">奖项名称</td>
            <td colspan="2" class="classA">授奖部门</td>
            <td class="classA">获奖级别及排名</td>
          </tr>
          <tr v-if="dataInfo.cvHonorList.length == 0">
            <td class="classB"></td>
            <td colspan="3" class="classB"></td>
            <td colspan="2" class="classB"></td>
            <td class="classB"></td>
          </tr>
          <tr v-for="item in dataInfo.cvHonorList" :key="item.id">
            <td class="classB">
              {{ item.honorDate ? formatDate('YYYY.MM', new Date(item.honorDate)) : '' }}
            </td>
            <td colspan="3" class="classB">{{ item.title }}</td>
            <td colspan="2" class="classB">{{ item.organization }}</td>
            <td class="classB">{{ item.level }}</td>
          </tr>
        </template>

        <tr style="height: 35px" :class="{ tip: dataInfo.cvHomeList.length == 0 }">
          <td :rowspan="dataInfo.cvHomeList.length ? dataInfo.cvHomeList.length + 1 : 2" class="classA">家庭主要<br />成员</td>
          <td class="classA">称谓</td>
          <td class="classA">姓名</td>
          <td class="classA">出生年月</td>
          <td class="classA" :class="{ tip: dataInfo.cvHomeList.some((i) => i.political === null) }">政治面貌</td>
          <td colspan="3" class="classA">现工作（学习）单位及职务</td>
        </tr>
        <tr v-if="dataInfo.cvHomeList.length == 0">
          <td class="classB"></td>
          <td class="classB"></td>
          <td class="classB"></td>
          <td class="classB"></td>
          <td colspan="3" class="classB"></td>
        </tr>
        <tr v-for="item in dataInfo.cvHomeList" :key="item.id">
          <td class="classB">
            {{ dicOptions.hr_relations.filter((d) => d.dictValue == item.relationship)[0]?.dictLabel }}
          </td>
          <td class="classB">{{ item.familyMember }}</td>
          <td class="classB">
            {{ item.birthday ? formatDate('YYYY.MM', new Date(item.birthday)) : '' }}
          </td>
          <td class="classB">
            {{ dicOptions.hr_political.filter((d) => d.dictValue == item.political)[0]?.dictLabel }}
          </td>
          <td colspan="3" class="classB">
            {{ [item.workUnit, item.position].filter((i) => i).join(' / ') }}
          </td>
        </tr>

        <template v-if="!isSpecific">
          <tr style="height: 100px">
            <td colspan="1" class="classA">奖惩情况</td>
            <td colspan="7" style="padding: 0 10px">
              <tr v-for="item in dataInfo.cvDesertList" :key="item.id">
                {{
                  [formatDate('YYYY年MM月 ', new Date(item.rewardDate)) + '获得' + item.rewardReason, item.rewardLevel, item.rewardOrganization]
                    .filter((i) => i)
                    .join(' | ')
                }}
              </tr>
            </td>
          </tr>
        </template>

        <template v-if="!isSpecific">
          <tr>
            <td colspan="1" style="height: 60px" class="classA">其他说明<br />事项</td>
            <td colspan="7" style="padding: 0 10px">
              {{ dataInfo.remark }}
            </td>
          </tr>
        </template>

        <tr id="ignoreTimePrint">
          <td colspan="1" style="height: 60px" class="classA" :class="{ tip: dataInfo.fileUrl == '[]' }">附件</td>
          <td colspan="7" style="padding: 0 10px">
            <a target="_blank" :href="JSON.parse(dataInfo.fileUrl || '[]')[0]?.url">{{ JSON.parse(dataInfo.fileUrl || '[]')[0]?.name }}</a>
          </td>
        </tr>

        <!-- <tr>
          <td colspan="1" class="classA" style="height: 100px">应聘承诺</td>
          <td colspan="7" style="padding: 0 10px; text-align: right">
            <tr style="text-align: left">
              本人承诺以上所填信息及提交的报名材料真实有效，如有虚假，愿意承担由此造成的一切后果。
            </tr>
            <br />
            <span>本人签名：</span>
            <img v-if="dataInfo.signUrl" :src="dataInfo.signUrl" height="40" style="margin-right: 120px" />
            <span style="margin-right: 30px">{{}}年</span>
            <span style="margin-right: 30px">月</span>
            <span>日</span>
          </td>
        </tr> -->
      </tbody>
    </table>
    <el-empty v-else :image-size="140" description="暂无简历">
      <el-button type="primary" size="small" @click="goResume">去填写简历</el-button>
    </el-empty>
  </div>
</template>

<script>
export default {
  name: 'Preview',
};
</script>

<script setup>
import { defineProps, reactive, ref, watch, computed, onActivated } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { formatDate } from '../../utils/tools';
import { BASIC, ACHIEVEMENT } from '../../utils/resume';
import { findAreaName } from '../../utils/operation';
import ApplicantApi from '../../service/api/applicant';

const store = useStore();
const dicOptions = computed(() => store.state.dicOptions);

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  job: {
    type: Object,
    default: () => null,
  },
  isSpecific: {
    type: Boolean,
    default: false,
  },
});

const dataInfo = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    dataInfo.value = props.modelValue || {};
  },
);

const router = useRouter();
const goResume = () => {
  if (store.state.isMobile) {
    return ElMessage.warning('为了更好地体验，请在PC端登录投递');
  }
  router.push('/resume');
};
</script>

<style lang="scss" scoped>
.classA {
  text-align: center;
  background: #f1f1f1;
  /* 背景色 */
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
  img {
    aspect-ratio: 5/7;
    object-fit: cover;
  }
}
.classB {
  text-align: center;
  height: 35px;
  font-family: 'Microsofe YaHei', 'Arial';
}
.tip {
  color: red;
}
table {
  width: 100%;
  border: 1px solid #333;
  border-collapse: collapse;
  margin-left: -1px;
}
</style>
